import { useMemo } from 'react'
import {
  dataFetchingError,
  dataFetchingLoading,
  type DataFetchingState,
  dataFetchingSuccess,
} from 'legacy/common/utils/data-fetching/dataFetching.types'
import { type Warehouse, AsyncStatus } from 'legacy/common/types'
import { useRequiredContext } from 'legacy/contexts/utils'
import { WarehousesContext } from 'legacy/contexts/warehouses/WarehousesContext'

type Result = DataFetchingState<Warehouse[]>

export const useRetailersList = (): Result => {
  const warehousesContext = useRequiredContext(WarehousesContext)

  const data = useMemo(() => {
    if (warehousesContext.status !== AsyncStatus.Done) {
      return []
    }

    return warehousesContext.warehouses
  }, [warehousesContext])

  if (warehousesContext.status === AsyncStatus.Fail) {
    return dataFetchingError<Warehouse[]>(new Error('Failed to fetch retailers list.'))
  }
  if (warehousesContext.status === AsyncStatus.Busy) {
    return dataFetchingLoading<Warehouse[]>()
  }

  return dataFetchingSuccess<Warehouse[]>(data)
}
